<template>
  <Layout>
    <div slot="body" class="not-found-container">
      <EmptyContent :emptyContentText="$t('errors.not_support_country')" />
      <div class="link-back-main">
        <a :href="classtingUrl" target="_brank">{{ $t('common.go_back_to_other_app') }}</a>
      </div>
    </div>
  </Layout>
</template>

<script>
  import { CLASSTING_URL } from '@/config';

  export default {
    name: 'not-support-country',

    computed: {
      classtingUrl() {
        return CLASSTING_URL;
      },
    },
  };
</script>

<style lang="scss" scoped>

 .not-found-container {
    max-width: 946px;
    margin: 14px auto;

    .link-back-main {
      text-align: center;

      a {
        cursor: pointer;
        color: #00c896;
      }
    }
 }

</style>




// WEBPACK FOOTER //
// NotSupportCountry.vue?8534ea78